import React from 'react'
import Greetings from './Greetings'
import { useNavigate, useSearchParams } from 'react-router-dom'
import Journal from './JournalWithoutAI'
import { useDispatch, useSelector } from 'react-redux'
import { setSetting } from '../../../Components/action/common'
import { pushToSetting } from '../../../redux/slices/SettingSclice'
import moment from 'moment'
import PlanYourDay from './PlanYourDayWithoutAI'
import MorningGratitude from './MorningGratitude'

const RitualsPage = () => {
    const [searchParams, setSearchParams] = useSearchParams() 
    const step = searchParams.get('step') ?? 'greetings'
    const steps = ['greetings', 'journal', 'plan-today']
    const stepIndex = steps.indexOf(step)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const settings = useSelector(state => state.settings.settings);

    const exitRituals = async (e) => {
        e.preventDefault();
        const newSettings = { ...settings, 'ritualsOk': moment().startOf('date').toISOString() };
        dispatch(pushToSetting(newSettings));

        try {
          await setSetting({ "settings": newSettings })
          navigate(process.env.REACT_APP_ROOT);
        } catch ({ response }) { }
    }

    return (
        <div className={`main-body-wrap rituals-page`}>
            <div className={`page-wrapper`} style={{maxHeight: '100vh', padding: '0px'}}>
                <div className={`page-container ${step} ${step === 'plan-today' ? 'justify-center items-center' : ''}`}>
                    {step === 'greetings'  && <Greetings />}
                    {step === 'gratitude' && <MorningGratitude />}
                    {step === 'journal' && <Journal />}
                    {step === 'plan-today' && <PlanYourDay />}
                </div>
                {/* <div id='rituals-progress-bar'>
                    <div className="progress-bar"></div>
                    <div className="progress-actions flex gap-[10px] items-center">
                        {
                            stepIndex > 0 &&
                            <Link to={`/morning-rituals?step=${steps[stepIndex - 1]}`} className="button primary font-inter font text-[14px] font-normal text-black back-step">
                                <ArrowLeft color="black" />
                            </Link>
                        }
                        {
                            stepIndex < steps.length - 1 &&
                            <Link to={`/morning-rituals?step=${steps[stepIndex + 1]}`} className="button primary lightBackgroundColor font-inter font text-[14px] font-normal text-black next-step">
                                <ArrowLeft color="black" />
                            </Link>
                        }
                        {
                            stepIndex > 0 &&
                            <a href="#" onClick={exitRituals} className="button primary font-inter font text-[14px] font-normal text-black back-step flex gap-[10px] items-center opacity-50">
                                <Cancel color="black" /> Exit
                            </a>
                        }
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default RitualsPage